import AUTHORS_CONFIG from "./authorsConfig";
import { getTopK } from "./getTopK";
import createPreferenceObject from "./preferences";
export {
    getTopKAuthors,
    parsePreferenceAuthors,
};

function getTopKAuthors(array, k = AUTHORS_CONFIG.targetingParamLimit) {
    return getTopK(array, k);
}

function parsePreferenceAuthors(userInfo) {
    const preferenceAuthors = [];
    const {
        Author: {
            Confidence = 0,
            Preferences = [],
        } = {},
    } = userInfo;

    if (Confidence < AUTHORS_CONFIG.confidenceThreshold) { // Only consider if confidence is greater than or equal to the threshold
        return preferenceAuthors;
    }

    if (!Array.isArray(Preferences)) {
        return preferenceAuthors;
    }

    Preferences.forEach((author) => {
        const preferredAuthor = createPreferenceObject(author, Confidence);

        if (preferredAuthor) {
            preferenceAuthors.push(preferredAuthor);
        }
    });

    return preferenceAuthors;
}
